module.exports = __webpack_public_path__ + "app/heySpace/favicons/default.png";